import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import config from 'src/replicant/config';
import { State } from 'src/replicant/State';

const initialState: State = {
  ...config.stateSchema.getDefault(),
  id: '',
  createdAt: 0,
  updatedAt: 0,
  lastLoginAt: undefined,
  ruleset: { abTests: {} },
  userSharedStates: {},
  loginCount: 1,
} as State; // replicant state schema default

const slice = createSlice({
  name: 'user',

  initialState,

  reducers: {
    update: (_, { payload }: PayloadAction<State>) => payload,
  },
});

export const { update } = slice.actions;
export default slice.reducer;
